import React from 'react'
import { connect } from 'react-redux'
import { fetchSets, addSets, sortSets, searchSets, filterSets } from "../../actions/settings"
import SetsSrvcItem from "./SetsSrvcItem"
import { isEmpty } from 'lodash'
import Select from 'react-select'
import { sortOpts } from '../../utils/utils'
import SettingsForm from './SettingsForm'

class SetsSrvc extends SettingsForm {

  componentWillMount(){
    this.props.fetchSets('srvc');
    this.props.fetchSets('srvg');
    this.setState({
      adding: false,
      data: this.newItem,
      errors: {}
    });
  }

  modelName = 'srvc'

  newItem = {
    srvc_desc: '',
    srvc_longdesc: '',
    srvc_type: 1,
    srvc_srvg_id: 0,
    srvc_active: 1,
    srvc_price: 0,
    srvc_cost: 0,
    srvc_post: 0,
    srvc_expense: 0
  };

  handleFilter = (e, val) => {
    e.preventDefault();
    this.props.filterSets('srvc', {
      ...this.props.srvcs.filter,
      type: val
    });
  }

  render() {
    if(isEmpty(this.props.srvcs.data)
      || isEmpty(this.props.srvgs.data)
    ){
      return(<div>Не загружены данные</div>);
    }
    const srvcs = this.props.srvcs.data;
    const { search, sort, filter } = this.props.srvcs;
    const srvgs = this.props.srvgs.data;
    srvgs[0] = {srvg_desc:''};
    const { data, errors } = this.state;

    var fltrSrvcs = [];
    for(var key in srvcs){
      if(srvcs.hasOwnProperty(key) && srvcs[key].srvc_active === 1){
        var found = true;
        var fltred = true;
        if(search !== ''){
          const searchValue = "" + srvcs[key].srvc_desc + srvcs[key].srvc_longdesc;
          found = searchValue.toLowerCase().indexOf(search) !== -1;
        }
        if(filter.type !== ''){
          if(filter.type === 'payment'){
            fltred = srvcs[key]["srvc_type"] === -1;
          }
          else if(srvcs[key].hasOwnProperty("srvc_"+filter.type)){
            fltred = srvcs[key]["srvc_"+filter.type] === 1 && srvcs[key]["srvc_type"] === 1;
          }
        }
        if(found && fltred){
          fltrSrvcs.push(srvcs[key]);
        }
      }
    }

    const srtSrvcs = fltrSrvcs.sort( (a, b) => {
      if(a[sort.field] < b[sort.field])
         return sort.asc ? -1 : 1
      if(a[sort.field] > b[sort.field])
         return sort.asc ? 1 : -1
      if(a.srvc_id < b.srvc_id)
         return sort.asc ? -1 : 1
      if(a.srvc_id > b.srvc_id)
         return sort.asc ? 1 : -1
      return 0
    });

    const mappedSrvcs = srtSrvcs ? srtSrvcs.map(srvc =>
      <SetsSrvcItem key={srvc.srvc_id}
        data={srvc}
        srvgs={srvgs}
      />
    ) : [];

    var srvgsOpt = [];
    for (key in srvgs){
      if(srvgs.hasOwnProperty(key) && (srvgs[key].srvg_active === 1
        || srvgs[key].srvg_id === data.srvc_srvg_id)) {
        srvgsOpt.push({value:srvgs[key].srvg_id,label:srvgs[key].srvg_desc});
      }
    }
    srvgsOpt.sort(sortOpts);

    const clearSearchBtn = <button
        type="button"
        className="btn btn-default"
        onClick={this.clearSearch}
        title="Очистить поиск">
        X
      </button>;

    const addNew = this.state.adding ?
      <tr>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.srvc_desc}
              name="srvc_desc"
              onChange={this.updateInput}
              placeholder="Краткое название"
              autoFocus
            />
            <textarea type="text"
              className="form-control"
              value={data.srvc_longdesc}
              name="srvc_longdesc"
              onChange={this.updateInput}
              placeholder="Длинное описание"
              title="Длинное описание"
            />
          </div>
          <div className="form-inline">
            <button  type="button" className="btn btn-success"
              onClick={this.saveItem} title="Сохранить">
              <span className="glyphicon glyphicon-save"></span>
            </button>{" "}
            <button type="button" className="btn btn-default"
              onClick={this.cancelAdding} title="Отменить">
              <span className="glyphicon glyphicon-remove"></span>
            </button>
          </div>
          {errors.form && <div className="alert alert-danger">{errors.form}</div>}
        </td>
        <td>
          <Select
            clearable={false}
            options={[{value:1,label:'Услуга'},{value:-1,label:'Оплата'}]}
            value={data.srvc_type}
            onChange={e => this.updateSelect(e,'srvc_type',this)}
            placeholder="Тип"
          />
        </td>
        <td>
          <Select
            clearable={false}
            options={srvgsOpt}
            value={data.srvc_srvg_id}
            onChange={e => this.updateSelect(e,'srvc_srvg_id',this)}
            placeholder="Группа услуг"
          />
          <label>
            Заказы{" "}
          <input type="checkbox" checked={data.srvc_post} name="srvc_post"
            onChange={this.handleChBox} />
          </label>{" "}
          <label>
            Издержки{" "}
          <input type="checkbox" checked={data.srvc_expense} name="srvc_expense"
            onChange={this.handleChBox} />
          </label>
        </td>
        <td>
          <input type="text"
            className="form-control"
            value={data.srvc_price}
            name="srvc_price"
            onChange={this.updateInput}
            placeholder="Цена"
          />
        </td>
        <td>
          <input type="text"
            className="form-control"
            value={data.srvc_cost}
            name="srvc_cost"
            onChange={this.updateInput}
            placeholder="Себес."
          />
        </td>
      </tr>
      :[];


    return (
      <div>
        <h3 className="pull-right">Настройка услуг</h3>
        <div className="form-group form-inline">
          <button className="btn btn-primary" onClick={this.startAdding}>Создать</button>
          {" "}
          <div className="input-group">
            <input
              type="search"
              className="form-control"
              value={search}
              title="Поиск"
              placeholder="Поиск"
              onChange={this.handleSearch} />
            <div className="input-group-btn">
              {clearSearchBtn}
            </div>
          </div>{" "}
          <div className="input-group">{fltrSrvcs.length} записей</div>
        </div>
        <ul className="nav nav-tabs">
          <li className={filter.type===''?"active":''}>
            <a onClick={(e)=>{this.handleFilter(e,'');}} href="#">Все</a>
          </li>
          <li className={filter.type==='post'?"active":''}>
            <a onClick={(e)=>{this.handleFilter(e,'post');}} href="#">Заказы</a>
          </li>
          <li className={filter.type==='expense'?"active":''}>
            <a onClick={(e)=>{this.handleFilter(e,'expense');}} href="#">Издержки</a>
          </li>
          <li className={filter.type==='payment'?"active":''}>
            <a onClick={(e)=>{this.handleFilter(e,'payment');}} href="#">Оплаты</a>
          </li>
        </ul>
        <table className="table table-striped table-hover sticky-50">
          <thead>
            <tr style={{cursor:'pointer'}}>
              <th className="col-sm-5" onClick={() => {this.handleSort('srvc_desc')}}>Краткое название</th>
              <th className="col-sm-1" onClick={() => {this.handleSort('srvc_type')}}>Тип</th>
              <th className="col-sm-4" onClick={() => {this.handleSort('srvc_srvg_id')}}>Группа услуг</th>
              <th className="col-sm-1" onClick={() => {this.handleSort('srvc_price')}}>Цена</th>
              <th className="col-sm-1" onClick={() => {this.handleSort('srvc_cost')}}>Себес.</th>
            </tr>
          </thead>
          <tbody>
            {addNew}
            {mappedSrvcs}
            <tr onClick={this.startAdding}>
              <td><u>Нажмите, чтобы добавить услугу</u></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    )

  }
}

function mapOrdersToProps(store) {
  return {
    srvcs: store.srvcs,
    srvgs: store.srvgs
  }
}

export default connect(mapOrdersToProps, { fetchSets, addSets, sortSets, searchSets, filterSets })(SetsSrvc);



// WEBPACK FOOTER //
// ./src/components/settings/SetsSrvc.js